import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IWatchesQuantityField {
	setWatchesQuantity: (value: null | number) => void;
}

const WatchesQuantityField: React.FC<IWatchesQuantityField> = ({ setWatchesQuantity }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterWatchesQuantity') }], [t]);

	return (
		<FormInput
			testId="WatchesQuantityField"
			name="watchesQuantity"
			label="watchesQuantityLabel"
			placeholder="watchesQuantityPlaceholder"
			type="number"
			onChangeNumber={setWatchesQuantity}
			validationRules={validationRules}
			min={1}
			max={10}
		/>
	);
};

export default React.memo(WatchesQuantityField);
